import { render } from "./subjectList.vue?vue&type=template&id=45fc03c1&scoped=true"
import script from "./subjectList.vue?vue&type=script&lang=js"
export * from "./subjectList.vue?vue&type=script&lang=js"

import "./subjectList.vue?vue&type=style&index=0&id=45fc03c1&scoped=true&lang=css"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fc03c1"]])

export default __exports__